import { ClientListStatus } from 'types/api/clientList';

export const STATUS_OPTIONS = [
  // {
  //   name: 'Готов к построению',
  //   value: ClientListStatus.NEW,
  //   roles: [],
  // },
  {
    name: 'Построен',
    value: ClientListStatus.MATCHED,
    roles: [],
  },
  {
    name: 'В процессе построения',
    value: ClientListStatus.MATCHING,
    roles: [],
  },
  {
    name: 'Размечен',
    value: ClientListStatus.MARKED,
    roles: [],
  },
  {
    name: 'Ошибка при построении',
    value: ClientListStatus.ERROR,
    roles: [],
  },
];
